import styled from 'styled-components/native';
import { themes } from '../../design/colors';
import { Feather as IconsFE, Ionicons as IconsIo } from '@expo/vector-icons';

export const Content = styled.View`
  flex: 1;
  justify-content: center;
  padding: 16px 16px 0 16px;
  align-items: center;
`;

export const TextButtonLogout = styled.Text`
  color: ${themes.colors.white};
  flex: 1;
  text-align: center;
  top: 15px;
  font-weight: bold;
  font-size: 16px;
`;

export const ButtonLogout = styled.TouchableOpacity`
  flex-direction: row;
  justify-content: space-between;
  height: 50px;
  border-radius: 5px;
  background-color: ${themes.colors.primary}; ;
`;

export const IconFE = styled(IconsFE)``;

export const IconIo = styled(IconsIo)``;

export const DataUser = styled.Text`
  font-size: 22px;
  color: ${themes.colors.gray3};
  font-weight: bold;
  text-transform: capitalize;
`;


export const Title = styled.Text`
  font-size: 20px;
  color: ${themes.colors.black};
  font-weight: bold;
`;

export const ContentAvatar = styled.View`
  align-items: center;
`;

export const ContentButton = styled.View`
  margin-bottom: 10px;
  padding: 16px 16px 0 16px;
`;